// extracted by mini-css-extract-plugin
export default {"root":"SearchModuleDates_root__f3tcM"};